import React, { useEffect, useState, useContext } from 'react';
import BuyGiftCard from '../Presentation/BuyGiftCard';

import { isMobileDevice } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';

export const windowResized = () => {
  return isMobileDevice(window.innerWidth);
};

const GiftCardContainer = props => {
  const { contentData = {} } = props;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderState } = useContext(UserOrderContext);

  useEffect(() => {
    window.addEventListener('resize', setMobileHeader(windowResized));
  }, [isMobile]);

  const desktopGiftCard = () => {
    return (
      <div className='giftCard-desktop-container'>
        {contentData && <BuyGiftCard contentData={contentData} isMobile={isMobile} />}
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  const mobileGiftCard = () => {
    return (
      <div className='giftCard-mobile-container'>
        {contentData && <BuyGiftCard contentData={contentData} isMobile={isMobile} />}
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  return isMobile ? mobileGiftCard() : desktopGiftCard();
};
export default GiftCardContainer;
